<template>
    <div id="produk">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Kode Referral',
                    href: '#/referral-code',
                    exact: true,
                },
                { text: 'Detail Kode Referral' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Detail Kode Referral</h3>

        <div>
            <v-card flat>
                <v-card-text class="px-8">
                    <v-row class="mt-2 mb-4">
                        <v-col cols="6" class="pt-3">
                            <v-row class="mb-4">
                                <v-col cols="4" class="font-weight-500">
                                    Email Pemilik
                                </v-col>
                                <v-col cols="8">
                                    <span
                                        class="darkgrey--text font-weight-bold"
                                    >
                                        {{ details.email }}
                                    </span>
                                </v-col>
                            </v-row>

                            <v-row class="mb-4">
                                <v-col cols="4" class="font-weight-500">
                                    User ID
                                </v-col>
                                <v-col cols="8">
                                    <span
                                        class="darkgrey--text font-weight-bold"
                                    >
                                        {{ details.user_id }}
                                    </span>
                                </v-col>
                            </v-row>

                            <v-row class="mb-4">
                                <v-col cols="4" class="font-weight-500">
                                    Sekolah
                                </v-col>
                                <v-col cols="8">
                                    <span
                                        class="darkgrey--text font-weight-bold"
                                    >
                                        {{ details.school }}
                                    </span>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="6" class="text-right">
                            <span class="mr-2 font-weight-700"
                                >Kode Referral</span
                            >

                            <span class="darkgrey--text font-weight-bold">
                                {{ details.referral_code }}
                            </span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </div>

        <div class="mb-10 mt-2">
            <v-row>
                <v-col cols="4">
                    <v-card flat class="mt-5">
                        <v-card-text class="pa-5">
                            <div class="grey--text">Total Penggunaan</div>
                            <div
                                class="font-weight-700 black--text mt-2"
                                style="font-size: 24px"
                            >
                                {{ details.total_usage }}
                                <span style="font-size: 14px">Pengguna</span>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-card>
            <v-card-title> Daftar Pengguna Kode Referral </v-card-title>

            <v-divider />

            <app-datatable
                :items="userList"
                :headers="headers"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-total-items="pagination.total_data"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value };
                    doFilter();
                "
            ></app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            deleteProduk(dialogConfirm.function);
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Moment from "moment";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Spinner from "@/modules/global/components/plugins/Spinner";
import SalesService from "@/modules/global/services/sales.js";

export default {
    name: "referral-code",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            search: [],
            userList: [],
            selectedRow: null,
            details: {
                user_id: "",
                email: "",
                referral_code: "",
                school: "",
                total_usage: "",
            },
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                total_data: 0,
                sortMode: "desc",
            },
            params: {
                email: "",
                order_id: "",
                usage_date: "",
                package_group: "",
                school: "",
                referral_code: "",
                page: 1,
                per_page: 10,
            },
            headers: [
                { text: "Email", value: "email", width: "200" },
                { text: "No. Handhone", value: "phone_number", width: "150" },
                { text: "Order ID", value: "order_id", width: "180" },
                {
                    text: "Tanggal Digunakan",
                    value: "date",
                    width: "180",
                    align: "center",
                },
                { text: "Paket Group", value: "package", width: "200" },
                { text: "Harga", value: "price", width: "150" },
                { text: "Sekolah", value: "school", width: "180" },
            ],
            headersKey: ["email", "order_id", "date", "package", "school"],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
        };
    },

    watch: {
        search() {
            this.fetchTable();
        },
        pagination() {
            this.fetchTable();
        },
    },

    mounted: function () {
        this.fetchData(this.$route.query.id);
    },

    methods: {
        fetchData: function (id) {
            var context = this;

            SalesService.detailReferralCode(id, function (result) {
                context.isLoading = false;
                if (result.success) {
                    context.details = result.data;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal mengambil data`,
                        type: "error",
                    });
                }
                context.fetchTable();

                return;
            });
        },

        fetchTable: function () {
            var context = this;

            this.params = {
                email: "",
                order_id: "",
                usage_date: "",
                package_group: "",
                school: "",
                referral_code: context.details.referral_code,
                page: context.pagination.currentPage,
                per_page: context.pagination.perPage,
            };

            if (!this.search.by || !this.search.query) {
                this.clearFilter();
            } else {
                this.params[this.search.by] = this.search.query;
            }

            if (this.search.length > 0) {
                this.search.forEach((data) => {
                    if (data.key.value === "email") {
                        this.params.email = data.value;
                    }
                    if (data.key.value === "order_id") {
                        this.params.order_id = data.value;
                    }
                    if (data.key.value === "date") {
                        this.params.usage_date = data.value;
                    }
                    if (data.key.value === "package") {
                        this.params.package_group = data.value;
                    }
                    if (data.key.value === "school") {
                        this.params.school = data.value;
                    }
                });
            }

            SalesService.getListReferralUsage(this.params, function (result) {
                context.userList = [];
                context.isLoading = false;

                if (result.success) {
                    context.pagination.totalPages = result.data.max_page;
                    context.pagination.total_data = result.data.total_data;
                    result.data.data.forEach(function (content, index) {
                        var row = {
                            no: index,
                            email: content.email,
                            order_id: content.order_id,
                            date: Moment(content.usage_date).format(
                                "YYYY-MM-DD"
                            ),
                            package: content.package,
                            phone_number: content.phone_number,
                            price: "Rp." + context.formatNumber(content.price),
                            school: content.school,
                        };

                        context.userList.push(row);
                    });
                    context.isLoading = false;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal mengambil data tabel`,
                        type: "error",
                    });
                }
                return;
            });
        },

        doFilter() {
            this.params.page = 1;
            this.pagination.currentPage = 1;
            this.fetchTable();
        },

        clearFilter() {
            this.params = {
                page: 1,
                per_page: this.pagination.perPage,
                email: "",
                order_id: "",
                usage_date: "",
                package_group: "",
                school: "",
                referral_code: this.details.referral_code,
            };
        },

        formatNumber(value = 0) {
            return new Intl.NumberFormat("id-ID", {
                maximumFractionDigits: 0,
            }).format(value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ReferralCodeDetail.vue?2ee48b92